// Blog registry. Metadata lives in post-meta.json (plain JSON so the sitemap and
// feed generator in scripts/ can read it without a bundler); this module adds the
// lazy component import per slug. Newest first in the JSON, sorted here anyway.
//
// Fields per post: slug (URL, kebab-case, unique), title, excerpt (one or two
// sentences, under 160 characters, doubles as the meta description), date
// (YYYY-MM-DD), category (eyebrow label), readingMinutes, image (public path for
// the share card), takeaways (two to four one-sentence answers shown at the top),
// faq ([{ q, a }], rendered after the body and published as FAQ structured data).

import meta from './post-meta.json';

const components = {
  'multiple-event-durations-with-per-duration-pricing': () =>
    import(/* webpackChunkName: "blog-post" */ './posts/multiple-event-durations.vue'),
};

const posts = meta.map(m => ({ ...m, component: components[m.slug] }));

export function allPosts() {
  return [...posts].sort((a, b) => (a.date < b.date ? 1 : -1));
}

export function findPost(slug) {
  return posts.find(p => p.slug === slug) || null;
}

export function formatPostDate(iso) {
  const d = new Date(iso + 'T00:00:00');
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default posts;
